import { FC, useEffect, useState } from "react";
import Modal from "react-modal";
import "./index.css";
import api from "../../services/api";
import Swal from "sweetalert2";
import {
  cepNoMask,
  cpfCnpjNoMask,
  telephoneNoMask,
} from "../../functions/mask";
import useAuth from "../../hooks/useAuth";
import { usePluginspace } from "../../hooks/usePluginspace";
import InputMask from "react-input-mask";
import { address } from "../../pages/Perfil/addresses/addressesIndex";
import { useOrder } from "../../hooks/useOrder";
import { useAppConfig } from "../../hooks/useAppConfig";
import { Loading } from "../Loading";
import { Input } from "../inputs/inputs";

type props = {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  setAddressOrder: (value: address) => void;
  verifyAddress: (value: any) => void;
  searchCep?: string;
};

const ModalCreateAddress: FC<props> = ({
  isOpen,
  setIsOpen,
  setAddressOrder,
  verifyAddress,
  searchCep,
}) => {
  const [cep, setCep] = useState("");
  const [loading, setLoading] = useState(false);
  const [address, setAddress] = useState("");
  const [district, setDistrict] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [number, setNumber] = useState("");
  const [complement, setComplement] = useState("");
  const [extra, setExtra] = useState("");
  const [ibge, setIbge] = useState("");

  const { loginInfo } = useAuth();
  const { getToken } = usePluginspace();

  async function findCep(cep: string) {
    if (cep) {
      setLoading(true);
      return await api
        .get(`https://viacep.com.br/ws/${cep.replace("-", "")}/json/`)
        .then((response) => {
          setLoading(false);
          if (response.data.erro) {
            setCity("");
            setAddress("");
            setDistrict("");
            setState("");
            Swal.fire({
              icon: "warning",
              title: "CEP inválido!",
              text: "Verifique se o CEP foi digitado corretamente.",
            });
            return false;
          } else {
            if (response.data.ibge !== "") setIbge(response.data.ibge);
            if (response.data.localidade !== "")
              setCity(response.data.localidade);
            if (response.data.logradouro !== "")
              setAddress(response.data.logradouro);
            if (response.data.bairro !== "") setDistrict(response.data.bairro);
            if (response.data.uf !== "") setState(response.data.uf);

            setLoading(false);
            return true;
          }
        })
        .catch(() => {
          setLoading(false);
          setCity("");
          setAddress("");
          setDistrict("");
          setState("");
          Swal.fire({
            icon: "warning",
            title: "CEP inválido!",
            text: "Verifique se o CEP foi digitado corretamente.",
          });
          return false;
        });
    } else {
      return false;
    }
  }

  async function saveAddress() {
    if (cep && address && district && city && state && number) {
      setLoading(true);
      const newAddress = {
        zipCode: cep ? cepNoMask(cep) : "",
        customerId: loginInfo.id,
        street: address,
        number: number,
        district: district,
        city: city,
        state: state,
        extra: complement,
        reference: "",
        typeAddress: "main",
        ibge,
      };

      return await api
        .post(`/api/customer/address`, newAddress, {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        })
        .then((response) => {
          setLoading(false);

          if (response.data.success === true) {
            return response.data;
          } else {
            Swal.fire({
              icon: "error",
              title: "Erro!",
              text: "Falha ao cadastrar endereço",
            });

            return response.data;
          }
        })
        .catch((err) => {
          console.log(err);

          Swal.fire({
            icon: "error",
            title: "Erro!",
            text: "Falha ao cadastrar endereço",
          });
          setLoading(false);
          console.log(err);
        });
    } else {
      Swal.fire({
        icon: "warning",
        title: "Atenção",
        text: "Verifique se preencheu todos os campos",
      });
    }
  }

  const continueOrder = async () => {
    //tenta criar o endereço pro cliente
    const response = await saveAddress();

    if (response && response.success) {
      // utilize o endereço criado como de entrega:
      const newAddress: address = { ...response.dados };

      setAddressOrder(newAddress);

      //fecha o modal
      setIsOpen(false);

      // verifica se está disponivel para entrega no endereço selecionado
      verifyAddress(cepNoMask(cep));
    }
  };

  async function shouldSearch() {
    if (searchCep && searchCep !== "") {
      setCep(searchCep);
      await findCep(searchCep);
    }
  }

  useEffect(() => {
    // shouldSearch()
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => setIsOpen(false)}
      className="modal-create"
      contentLabel="Criar endereço para entrega"
      overlayClassName="overlay-modal"
      ariaHideApp={false}
    >
      <div className="modal-create-content">
        <div className="modal-create-body">
          <div className="modal-create-body-header">
            <h4>Adicionar endereço</h4>

            {!loading && (
              <svg
                onClick={() => setIsOpen(false)}
                width="17"
                height="17"
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0.978551 2.97126L6.957 8.94971L0.978551 14.9282L2.97137 16.921L8.94981 10.9425L14.9283 16.921L16.9211 14.9282L10.9426 8.94971L16.9211 2.97126L14.9283 0.978446L8.94981 6.95689L2.97137 0.978446L0.978551 2.97126Z"
                  fill="#636363"
                />
              </svg>
            )}
          </div>

          {loading ? (
            <Loading
              type="spinningBubbles"
              color="#FFF"
              width={64}
              height={64}
            />
          ) : (
            <>
              <div className="modal-create-body-content">
                {/*CEP */}
                <div className="createCEP">
                  <label>
                    CEP
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="8"
                      height="9"
                      viewBox="0 0 8 9"
                      fill="none"
                    >
                      <circle cx="4" cy="4.5" r="4" fill="#37393D" />
                    </svg>
                  </label>
                  <div className="inputCep">
                    <InputMask
                      className={`inputsContainer`}
                      mask="99999-999"
                      type="text"
                      placeholder="00000-000"
                      value={cep}
                      onChange={(event) => setCep(event.target.value)}
                      onBlur={(event) => {
                        findCep(event.target.value);
                      }}
                    />
                  </div>
                </div>

                {/*Cidade estado */}
                <div className="inputGroupAddresses">
                  <div className="createCEP">
                    <label>
                      Cidade
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="8"
                        height="9"
                        viewBox="0 0 8 9"
                        fill="none"
                      >
                        <circle cx="4" cy="4.5" r="4" fill="#37393D" />
                      </svg>
                    </label>
                    <div className="inputCep">
                      <input
                        className={`inputsContainer`}
                        type="text"
                        placeholder="São Paulo"
                        value={city}
                        onChange={(event) => setCity(event.target.value)}
                        onBlur={(event) => {}}
                      />
                    </div>
                  </div>
                  <div className="createCEP">
                    <label>
                      Estado
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="8"
                        height="9"
                        viewBox="0 0 8 9"
                        fill="none"
                      >
                        <circle cx="4" cy="4.5" r="4" fill="#37393D" />
                      </svg>
                    </label>
                    <div className="inputCep">
                      <input
                        className={`inputsContainer`}
                        type="text"
                        placeholder="SP"
                        value={state}
                        onChange={(event) => setState(event.target.value)}
                        onBlur={(event) => {}}
                      />
                    </div>
                  </div>
                </div>

                {/*Logradouro className=`inputGroupAddresses` */}
                <div className="inputGroupAddresses">
                  <div className="createCEP">
                    <label>
                      Endereço
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="8"
                        height="9"
                        viewBox="0 0 8 9"
                        fill="none"
                      >
                        <circle cx="4" cy="4.5" r="4" fill="#37393D" />
                      </svg>
                    </label>
                    <div className="inputCep">
                      <input
                        className={`inputsContainer`}
                        type="text"
                        placeholder="Rua"
                        value={address}
                        onChange={(event) => setAddress(event.target.value)}
                        onBlur={(event) => {}}
                      />
                    </div>
                  </div>
                  <div className="createCEP">
                    <label>
                      Número
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="8"
                        height="9"
                        viewBox="0 0 8 9"
                        fill="none"
                      >
                        <circle cx="4" cy="4.5" r="4" fill="#37393D" />
                      </svg>
                    </label>
                    <div className="inputCep">
                      <input
                        className={`inputsContainer`}
                        type="text"
                        placeholder="104"
                        value={number}
                        onChange={(event) => setNumber(event.target.value)}
                        onBlur={(event) => {}}
                      />
                    </div>
                  </div>
                </div>

                {/*Numero e Complemento */}
                <div className="">
                  <div className="createCEP">
                    <label>
                      Bairro
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="8"
                        height="9"
                        viewBox="0 0 8 9"
                        fill="none"
                      >
                        <circle cx="4" cy="4.5" r="4" fill="#37393D" />
                      </svg>
                    </label>
                    <div className="inputCep">
                      <input
                        className={`inputsContainer`}
                        type="text"
                        value={district}
                        placeholder="Bairro"
                        onChange={(event) => setDistrict(event.target.value)}
                        onBlur={(event) => {}}
                      />
                    </div>
                  </div>
                  <div className="createCEP">
                    <label>
                      Complemento
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="8"
                        height="9"
                        viewBox="0 0 8 9"
                        fill="none"
                      >
                        <circle cx="4" cy="4.5" r="4" fill="#37393D" />
                      </svg>
                    </label>
                    <div className="inputCep">
                      <input
                        className={`inputsContainer`}
                        type="text"
                        placeholder="Bloco 2"
                        value={complement}
                        onChange={(event) => setComplement(event.target.value)}
                        onBlur={(event) => {}}
                      />
                    </div>
                  </div>
                  <div className="createCEP">
                    <label>
                      Nome deste endereço
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="8"
                        height="9"
                        viewBox="0 0 8 9"
                        fill="none"
                      >
                        <circle cx="4" cy="4.5" r="4" fill="#37393D" />
                      </svg>
                    </label>
                    <div className="inputCep">
                      <input
                        className={`inputsContainer`}
                        type="text"
                        placeholder="(Exemplo: casa, trabalho, etc)"
                        value={extra}
                        onChange={(event) => setExtra(event.target.value)}
                        onBlur={(event) => {}}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/*Botão de Salvar */}
              <div className="saveButton">
                <button onClick={() => continueOrder()}>
                  <span>Salvar</span>
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </Modal>
  );
};

export { ModalCreateAddress };

type Props = {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  setAddressOrder: (value: address) => void;
  verifyAddress: (value: any) => void;
  searchCep?: string;
  setAllAddress: (value: any) => void;
  allAddress: any;
  customerInfoComplete: any;
  setCepList?: (value: string) => void;
};

const ModalCreateAddressNoLogin: FC<Props> = ({
  isOpen,
  setIsOpen,
  setAddressOrder,
  verifyAddress,
  searchCep,
  setAllAddress,
  allAddress,
  customerInfoComplete,
  setCepList,
}) => {
  const { getAppConfig } = useAppConfig();
  const [cep, setCep] = useState("");
  const [loading, setLoading] = useState(false);
  const [address, setAddress] = useState("");
  const [district, setDistrict] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [number, setNumber] = useState("");
  const [complement, setComplement] = useState("");
  const [extra, setExtra] = useState("");
  const [ibge, setIbge] = useState("");

  const { getToken } = usePluginspace();
  const { customer } = useOrder();

  async function findCep(cep: string) {
    if (cep) {
      setLoading(true);
      return await api
        .get(`https://viacep.com.br/ws/${cep.replace("-", "")}/json/`)
        .then((response) => {
          setLoading(false);
          if (response.data.erro) {
            setCity("");
            setAddress("");
            setDistrict("");
            setState("");
            Swal.fire({
              icon: "warning",
              title: "CEP inválido!",
              text: "Verifique se o CEP foi digitado corretamente.",
            });
            return false;
          } else {
            if (response.data.ibge !== "") setIbge(response.data.ibge);
            if (response.data.localidade !== "")
              setCity(response.data.localidade);
            if (response.data.logradouro !== "")
              setAddress(response.data.logradouro);
            if (response.data.bairro !== "") setDistrict(response.data.bairro);
            if (response.data.uf !== "") setState(response.data.uf);

            setLoading(false);
            return true;
          }
        })
        .catch(() => {
          setLoading(false);
          setCity("");
          setAddress("");
          setDistrict("");
          setState("");
          Swal.fire({
            icon: "warning",
            title: "CEP inválido!",
            text: "Verifique se o CEP foi digitado corretamente.",
          });
          return false;
        });
    } else {
      return false;
    }
  }

  async function saveAddress() {
    const config = await getAppConfig();
    if (
      cep &&
      address &&
      district &&
      city &&
      state &&
      number &&
      customerInfoComplete &&
      extra
    ) {
      const newAddress = {
        zipCode: cep ? cepNoMask(cep) : "",
        street: address,
        number: number,
        district: district,
        city: city,
        state: state,
        complement: complement,
        extra: extra,
        reference: complement,
        typeAddress: "delivery",
        ibge,
      };

      const customerToSend = {
        name: customerInfoComplete.name,
        email: customerInfoComplete.email,
        phones: [
          {
            typePhone: "cell",
            numberPhone: telephoneNoMask(
              customerInfoComplete.customerPhones[0].numberPhone
            ),
          },
        ],
        doc: cpfCnpjNoMask(customerInfoComplete.doc),
        cpf: cpfCnpjNoMask(customerInfoComplete.doc),
        optinWhatsapp: customerInfoComplete.optinWhatsapp ? true : false,
        birthDate: customerInfoComplete.birthDate,
        gender: customerInfoComplete.gender,
        lgpdDataAceiteCarta: customerInfoComplete.lgpdDataAceiteCarta,
        password: "",
        inscEstadual: customerInfoComplete.inscEstadual,
        addresses: [newAddress],
        pluginconfigId: config?.content.pdv.pluginconfigId
          ? config?.content.pdv.pluginconfigId
          : 0,
      };

      setLoading(true);
      return await api
        .post(`/api/customer`, customerToSend, {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        })
        .then((response) => {
          setLoading(false);

          if (response.data.success === true) {
            const addressCreated = response.data.dados.dados.addresses[0];
            setAllAddress([...allAddress, addressCreated]);
            return response.data;
          } else {
            Swal.fire({
              icon: "error",
              title: "Erro!",
              text: "Falha ao cadastrar endereço",
            });

            return response.data;
          }
        })
        .catch((err) => {
          console.log(err);

          Swal.fire({
            icon: "error",
            title: "Erro!",
            text: "Falha ao cadastrar endereço",
          });
          setLoading(false);
          console.log(err);
        });
    } else {
      Swal.fire({
        icon: "warning",
        title: "Atenção",
        text: "Verifique se preencheu todos os campos",
      });
      return {
        success: false,
        dados: {},
      };
    }
  }

  const continueOrder = async () => {
    //tenta criar o endereço pro cliente
    const response = await saveAddress();

    if (response && response.success) {
      setCepList && setCepList(response.dados.dados.addresses[0].zipCode);
      setIsOpen(false);
      verifyAddress(response.dados.dados.addresses[0].zipCode);
    }
  };

  async function shouldSearch() {
    if (searchCep && searchCep !== "") {
      setCep(searchCep);
      await findCep(searchCep);
    }
  }

  useEffect(() => {
    // shouldSearch()
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => setIsOpen(false)}
      className="modal-create"
      contentLabel="Criar endereço para entrega"
      overlayClassName="overlay-modal"
      ariaHideApp={false}
    >
      <div className="modal-create-content">
        <div className="modal-create-body">
          <div className="modal-create-body-header">
            <h4>Adicionar endereço</h4>

            {!loading && (
              <svg
                onClick={() => setIsOpen(false)}
                width="17"
                height="17"
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0.978551 2.97126L6.957 8.94971L0.978551 14.9282L2.97137 16.921L8.94981 10.9425L14.9283 16.921L16.9211 14.9282L10.9426 8.94971L16.9211 2.97126L14.9283 0.978446L8.94981 6.95689L2.97137 0.978446L0.978551 2.97126Z"
                  fill="#636363"
                />
              </svg>
            )}
          </div>
          {loading && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0,0,0,0.6)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
              <Loading
                type="spinningBubbles"
                color="#FFF"
                width={64}
                height={64}
              />
            </div>
          )}
          <>
            <div className="modal-create-body-content">
              {/*CEP */}
              <Input
                inputAttr={{
                  type: "cep",
                }}
                label="CEP"
                placeholder="12345-678"
                value={cep}
                hasDot={true}
                // warning={alarmCpf}
                change={(value: string) => {
                  setCep(value);
                }}
                blur={(value) => findCep(value)}
              />
              {/*Cidade estado */}
              <div className="inputGroupAddresses">
                <Input
                  inputAttr={{
                    type: "default",
                  }}
                  label="Cidade"
                  placeholder="Cidade"
                  value={city}
                  change={(value: string) => {
                    setCity(value);
                  }}
                  hasDot={true}
                />

                <Input
                  inputAttr={{
                    type: "default",
                  }}
                  label="Estado"
                  placeholder="Estado"
                  value={state}
                  change={(value: string) => {
                    setState(value);
                  }}
                  hasDot={true}
                />
              </div>

              {/*Logradouro className=`inputGroupAddresses` */}
              <div className="inputGroupAddresses">
                <Input
                  inputAttr={{
                    type: "default",
                  }}
                  label="Endereço"
                  placeholder="Rua"
                  value={address}
                  change={(value: string) => {
                    setAddress(value);
                  }}
                  hasDot={true}
                />
                <Input
                  inputAttr={{
                    type: "default",
                  }}
                  label="Número"
                  placeholder="000"
                  value={number}
                  change={(value: string) => {
                    setNumber(value);
                  }}
                  hasDot={true}
                />
              </div>

              {/*Numero e Complemento */}

              <Input
                inputAttr={{
                  type: "default",
                }}
                label="Bairro"
                placeholder="Bairro"
                value={district}
                change={(value: string) => {
                  setDistrict(value);
                }}
                hasDot={true}
              />

              <Input
                inputAttr={{
                  type: "default",
                }}
                label="Complemento"
                placeholder="Bloco 2"
                value={complement}
                change={(value: string) => {
                  setComplement(value);
                }}
              />
              <Input
                inputAttr={{
                  type: "default",
                }}
                label="Nome deste endereço"
                placeholder="(Exemplo: casa, trabalho, etc)"
                value={extra}
                change={(value: string) => {
                  setExtra(value);
                }}
                hasDot={true}
              />
            </div>
            <div className="legend">
              <span>
                * Os campos com{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="8"
                  height="9"
                  viewBox="0 0 8 9"
                  fill="none"
                >
                  <circle cx="4" cy="4.5" r="4" fill="#EB5353" />
                </svg>{" "}
                são obrigatórios
              </span>
            </div>
            {/*Botão de Salvar */}
            <div className="saveButton">
              <button onClick={() => continueOrder()}>
                <span>Salvar</span>
              </button>
            </div>
          </>
        </div>
      </div>
    </Modal>
  );
};

export { ModalCreateAddressNoLogin };

type PropsNew = {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  address: address;
  setAllAddress: (value: any) => void;
  allAddress: any[];
  verifyAddress: (cep: string) => any;
  setCepList: (value: string) => void;
};

const ModalEditAddress: FC<PropsNew> = ({
  isOpen,
  setIsOpen,
  address,
  setAllAddress,
  allAddress,
  verifyAddress,
  setCepList,
}) => {
  const [loading, setLoading] = useState(false);
  const [cep, setCep] = useState("");
  const [logradouro, setLogradouro] = useState("");
  const [district, setDistrict] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [number, setNumber] = useState("");
  const [complement, setComplement] = useState("");
  const [extra, setExtra] = useState("");
  const [ibgeCode, setIbgeCode] = useState("");

  const { getToken } = usePluginspace();

  useEffect(() => {
    if (address) {
      setCep(address.zipCode);
      setLogradouro(address.street);
      setDistrict(address.district);
      setCity(address.city);
      setState(address.state);
      setNumber(address.number);
      setComplement(address.complement);
      setExtra(address.extra || "");
      setIbgeCode(address.ibgeCode);
    }
  }, [address]);

  const findCep = async (cepValue: string) => {
    if (!cepValue) return;

    setLoading(true);
    try {
      const response = await api.get(
        `https://viacep.com.br/ws/${cepValue.replace("-", "")}/json/`
      );

      if (response.data.erro) {
        setCity("");
        setLogradouro("");
        setDistrict("");
        setState("");
        Swal.fire({
          icon: "warning",
          title: "CEP inválido!",
          text: "Verifique se o CEP foi digitado corretamente.",
        });
      } else {
        setIbgeCode(response.data.ibge || "");
        setCity(response.data.localidade || "");
        setLogradouro(response.data.logradouro || "");
        setDistrict(response.data.bairro || "");
        setState(response.data.uf || "");
      }
    } catch (err) {
      setCity("");
      setLogradouro("");
      setDistrict("");
      setState("");
      Swal.fire({
        icon: "warning",
        title: "CEP inválido!",
        text: "Verifique se o CEP foi digitado corretamente.",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = async () => {
    if (!cep || !logradouro || !district || !city || !state || !number) {
      Swal.fire({
        icon: "warning",
        title: "Atenção",
        text: "Preencha todos os campos obrigatórios.",
      });
      return;
    }

    const updatedDto = {
      customerId: address.customerId,
      addressId: address.id,
      zipCode: cepNoMask(cep),
      street: logradouro,
      number,
      district,
      city,
      state,
      complement,
      extra,
      reference: complement,
      typeAddress: address.typeAddress,
    };

    setLoading(true);
    try {
      const token = await getToken();
      const response = await api.put("/api/customer/address", updatedDto, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data.success) {
        const updatedList = allAddress.map((addr: any) =>
          addr.id === address.id ? { ...address, ...updatedDto } : addr
        );
        setAllAddress(updatedList);
        verifyAddress(updatedDto.zipCode);
        setCepList && setCepList(updatedDto.zipCode);
        setIsOpen(false);
      } else {
        Swal.fire({
          icon: "error",
          title: "Erro!",
          text: "Falha ao editar endereço.",
        });
      }
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: "Erro!",
        text: "Falha ao editar endereço.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => setIsOpen(false)}
      className="modal-create"
      overlayClassName="overlay-modal"
      ariaHideApp={false}
    >
      <div className="modal-create-content">
        <div className="modal-create-body">
          <div className="modal-create-body-header">
            <h4>Editar endereço</h4>
            {!loading && (
              <svg
                onClick={() => setIsOpen(false)}
                width="17"
                height="17"
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0.978551 2.97126L6.957 8.94971L0.978551 14.9282L2.97137 16.921L8.94981 10.9425L14.9283 16.921L16.9211 14.9282L10.9426 8.94971L16.9211 2.97126L14.9283 0.978446L8.94981 6.95689L2.97137 0.978446L0.978551 2.97126Z"
                  fill="#636363"
                />
              </svg>
            )}
          </div>

          {loading && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0,0,0,0.6)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 9999,
              }}
            >
              <Loading
                type="spinningBubbles"
                color="#FFF"
                width={64}
                height={64}
              />
            </div>
          )}
          <>
            <div className="modal-create-body-content">
              <Input
                label="CEP"
                inputAttr={{ type: "cep" }}
                value={cep}
                hasDot
                change={setCep}
                blur={findCep}
              />
              <div className="inputGroupAddresses">
                <Input
                  label="Cidade"
                  value={city}
                  change={setCity}
                  hasDot
                  inputAttr={{ type: "default" }}
                />
                <Input
                  label="Estado"
                  value={state}
                  change={setState}
                  hasDot
                  inputAttr={{ type: "default" }}
                />
              </div>
              <div className="inputGroupAddresses">
                <Input
                  label="Endereço"
                  value={logradouro}
                  change={setLogradouro}
                  hasDot
                  inputAttr={{ type: "default" }}
                />
                <Input
                  label="Número"
                  value={number}
                  change={setNumber}
                  hasDot
                  inputAttr={{ type: "default" }}
                />
              </div>
              <Input
                label="Bairro"
                value={district}
                change={setDistrict}
                hasDot
                inputAttr={{ type: "default" }}
              />
              <Input
                label="Complemento"
                value={complement}
                change={setComplement}
                inputAttr={{ type: "default" }}
              />
              <Input
                label="Nome do endereço"
                value={extra}
                change={setExtra}
                hasDot
                inputAttr={{ type: "default" }}
              />
            </div>
            <div className="legend">
              <span>
                * Os campos com{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="8"
                  height="9"
                  viewBox="0 0 8 9"
                  fill="none"
                >
                  <circle cx="4" cy="4.5" r="4" fill="#EB5353" />
                </svg>{" "}
                são obrigatórios
              </span>
            </div>
            <div className="saveButton">
              <button onClick={handleUpdate}>
                <span>Salvar</span>
              </button>
            </div>
          </>
        </div>
      </div>
    </Modal>
  );
};

export { ModalEditAddress };
